import Vuex from 'vuex';
import Vue from 'vue';
import VueRouter from 'vue-router';
import createPersistedState from 'vuex-persistedstate';
import Cookies from 'js-cookie';
import router from '../router';

Vue.use(Vuex);
Vue.use(VueRouter);

const getDefaultState = () => ({
  country: false,
  step: -1,
  totalSteps: 10,
  severities: {},
});

const store = new Vuex.Store({
  strict: true,
  state: getDefaultState(),
  mutations: {
    setCountry(state, value) {
      // eslint-disable-next-line no-param-reassign
      state.country = value;
    },
    setSeverityValue(state, payload) {
      // eslint-disable-next-line no-param-reassign
      state.severities = payload;
    },
    setStep(state, step) {
      // eslint-disable-next-line no-param-reassign
      state.step = step;
    },
    resetToDefaultState(state, payload) {
      // eslint-disable-next-line no-param-reassign
      state.country = payload.country;
      // eslint-disable-next-line no-param-reassign
      state.step = payload.step;
      // eslint-disable-next-line no-param-reassign
      state.totalSteps = payload.totalSteps;
      // eslint-disable-next-line no-param-reassign
      state.severities = payload.severities;
    },
  },
  actions: {
    setSeverityValue({ commit, state }, payload) {
      // eslint-disable-next-line no-param-reassign
      state.severities[payload.storage] = payload.value;
      commit('setSeverityValue', state.severities);
    },
    resetState({ commit, state }) {
      const defaultState = getDefaultState();
      commit('resetToDefaultState', defaultState);
    },
  },
  getters: {
    country: (state) => {
      if (state.country !== false) {
        return state.country;
      }
      return router.currentRoute.params.country;
    },
    step: (state) => {
      if (state.step !== -1) {
        return state.step;
      }
      return parseInt(router.currentRoute.params.step, 10);
    },
    severities: (state) => (storage) => {
      if (typeof state.severities[storage] !== 'undefined') {
        return state.severities[storage];
      }
      return null;
    },
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => Cookies.get(key),
        setItem: (key, value) => Cookies.set(key, value, { expires: 1 / 24, secure: false }),
        removeItem: (key) => Cookies.remove(key),
      },
    }),
  ],
});

export default store;
